<label *ngIf="label !== ''" [for]="label" class="setter-label">{{
  label
}}</label>
<div class="value-setter-container">
  <!-- [disabled]="disableDec" -->
  <app-primary-button
    class="setter-plus"
    label="-"
    (click)="decrementVal($event)"
  ></app-primary-button>
  <input
    class="setter-input"
    appearance="outline"
    matInput
    [id]="label"
    type="text"
    [min]="minValue"
    [max]="maxValue"
    [(ngModel)]="value"
    (change)="inputVal($event, value)"
  />
  <!-- [disabled]="disableInc" -->
  <app-primary-button
    class="setter-minus"
    label="+"
    (click)="incrementVal($event)"
  ></app-primary-button>
</div>